import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';

// Self-hosted (via @fontsource) — nunca CDN do Google Fonts, app roda atrás
// de TLS próprio.
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
